(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["daycora-frost-inquiry"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('daycora-frost-inquiry')) {
    customElements.define('daycora-frost-inquiry', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const substrate = this.querySelector('[data-substrate]');
        const thickness = this.querySelector('[data-thickness]');
        const choices = Array.from(thickness.options).map(option => option.cloneNode(true));
        const update = () => {
          const material = substrate.selectedOptions[0]?.dataset.material;
          const previous = thickness.value;
          thickness.replaceChildren(...choices.filter(option => !option.dataset.materials || option.dataset.materials.split(' ').includes(material)).map(option => option.cloneNode(true)));
          thickness.disabled = !material;
          if (Array.from(thickness.options).some(option => option.value === previous)) thickness.value = previous;
        };
        substrate.addEventListener('change', update);
        window.addEventListener('pageshow', update);
        update();
        this.querySelector('form').addEventListener('submit', () => this.querySelector('details').open = true);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
